import store from '@/store'
import *as baseApi from '@/Api/baseApi'
//加工商
export async function get_procSupplier(that, query) {
    if (query !== '') {
        that.loading2 = true;
        baseApi.searchProcSupplier({ supplierName: query, pageSize: 10, currentPage: 1 }, that).then(res => {
            that.procSupplier_options = res.records
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}
export async function get_procMaterial(that, query) {
    if (query !== '') {
        that.loading2 = true;
        baseApi.searchProcMaterial({ materialName: query, pageSize: 10, currentPage: 1 }, that).then(res => {
            that.procMaterial_options = res.records
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}
export async function get_project(that, query) {
    if (query !== '') {
        that.loading2 = true;
        baseApi.searchProject({ keyword: query, pageSize: 10, currentPage: 1 }, that).then(res => {
            that.project_options = res.records
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}
export async function queryPurMaterial(that, query) {
    if (query != '') {
        that.loading2 = true
        let param = {
            materialName: query,
            projectId: that.searchobj.projectId
        }
        baseApi.searchPurMaterial(param, that).then(res => {
            that.material_options = res
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}
export async function get_material(that, query) {
    if (query != '') {
        that.loading2 = true
        let param = {
            pageSize: 20,
            currentPage: 1,
            keyword: query
        }
        baseApi.searchMaterial(param, that).then(res => {
            that.material_options = res.records
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}
export async function get_supplier(that, query) {
    if (query != '') {
        that.loading2 = true
        let param = {
            pageSize: 10,
            currentPage: 1,
            keyword: query
        }
        baseApi.searchSupplier(param, that).then(res => {
            that.supplier_options = res.records
        }).catch(() => { }).finally(() => {
            that.loading2 = false
        })
    }
}

export function formatDateYear(dateString) {
    if (!dateString) return ''
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}